class SizeGuideController extends HTMLElement {
    constructor() {
      super();
      this.observeKiwiSizingContainer = this.observeKiwiSizingContainer.bind(this);
      this.observeEscSizeGuide = this.observeEscSizeGuide.bind(this);
    }
  
    connectedCallback() {
      this.kiwiSizingContainer = this.querySelector('#kiwiSizingContainer');
      this.escSizeGuideContainer = this.querySelector('.esc_size-guide');
      this.tts = this.querySelector('.tts');
      
      if (this.kiwiSizingContainer) {
        this.observeKiwiSizingContainer();
      }
      if (this.escSizeGuideContainer) {
        this.observeEscSizeGuide();
      }
    }
  
    observeKiwiSizingContainer() {
      const kiwiObserver = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList' && this.kiwiSizingContainer.children.length > 0) {
            this.tts.classList.add('hidden');
            this.escSizeGuideContainer.classList.add('hidden');
            observer.disconnect(); 
            break;
          }
        }
      });
  
      kiwiObserver.observe(this.kiwiSizingContainer, { childList: true, subtree: true });
    }
    
    observeEscSizeGuide() {
      const escObserver = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList' && this.escSizeGuideContainer.querySelector('.eastsideco_sizeGuides').children.length > 0) {
            this.tts.classList.add('hidden');
            observer.disconnect(); 
            break;
          }
        }
      });
      
      escObserver.observe(this.escSizeGuideContainer, { childList: true, subtree: true });
    }
  }
  
customElements.define('size-guide-controller', SizeGuideController);
